export default __webpack_public_path__ + "static/media/work_web-lg@1x.9860d994.jpg";